function onInputHandler(){
  let elements = document.querySelectorAll('.product__quantity-input');

  for(element of elements){
    element.addEventListener('input', function(){
          console.log(this.dataset.product)
      validate(this.value);
    });
  }
}


function validate(field){

        let error = document.querySelector('#quant_error');
        let btnCart = document.querySelector('#submitCart');
        if(field != undefined && field.length === 0 && isNaN(field)){
            error.style.color="red";
            error.style.display="block";
            error.innerHTML = "*** can't be blank"; 
            btnCart.disabled = true;
          console.log("if")
           
        }
        else if (field == 0){
          error.style.color="red";
            error.style.display="block";
            error.innerHTML = "*** unveiled number"; 
            btnCart.disabled = true;           
           console.log("else if1")
        }
        else if(/[^0-9]+/.test(field)){
            error.style.color="red";
            error.style.display="block";
            error.innerHTML = "*** unveiled number"; 
            btnCart.disabled = true; 
          let input= document.querySelectorAll('.product__quantity-input');
          for(input_value of input){
            input_value.value=0;
          }
          
          console.log("else if2")
         
        }
     
        else{
          console.log("else")
          error.style.display="none";
          btnCart.disabled = false;
       
        }

}

function init(){
  console.log("init")
  let nodelIst = document.querySelectorAll('.quant_btn');
  for(i=0; i<nodelIst.length; i++){
      nodelIst[i].addEventListener('click', function(){
         console.log('click')
        let num=document.querySelector('.product__quantity-input').value;
        console.log('num='+ num)
        if(num === ''){
           console.log('NaN')
          document.querySelector('.product__quantity-input').value=0;
        }
         else if (isNaN(field)){
         let input= document.querySelectorAll('.product__quantity-input');
          for(input_value of input){
            input_value.value=1;
          }
      }
      setTimeout(()=>{
        let field = document.querySelector('.product__quantity-input').value;       
        validate(field);
      }, 1000);    
    });
  }
  onInputHandler();
}

const quickAddBtns = document.querySelectorAll(".product-listing__quickview-trigger");

for(quickBtn of quickAddBtns){
  quickBtn.addEventListener('click', function(){   
    setTimeout(init, 3000);
  });
}

init();